import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { ImportListVm } from '../../shared/generated/Imports/Models/ImportList/ViewModel/ImportListVm';
import { TableComponent } from '../../shared/table/table.component';
import { ImportHistoryStatusEnum } from '../../core/enums/generated/ImportHistoryStatusEnum';
import { SystemMessageService } from '../../core/system-message/system-message-service';
import { saveAs } from 'file-saver';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonFilterService } from 'app/shared/table/table-top/button-filter/button-filter.service';

@Component({
    selector: 'pcg-import-list',
    templateUrl: './import-list.component.html',
    styleUrls: ['./import-list.component.scss'],
    standalone: false
})
export class ImportListComponent implements OnDestroy {
	@ViewChild(TableComponent) table: TableComponent<ImportListVm>;
	columns = ImportListVm.ColumnDefs;
	subscriptions: Subscription = new Subscription();
	importHistoryStatusEnum = ImportHistoryStatusEnum;

	filters = {
		vendorId: null,
	};
	initFilters = Object.assign({}, this.filters);

	filterMap = {
		vendorId: 'Client',
	};

	actionHistory: any;

	constructor(
		public title: Title,
		private httpClient: HttpClient,
		private messageService: SystemMessageService,
		private modalService: NgbModal, 
		public btnFilterService: ButtonFilterService
	) {
		title.setTitle('Portal');
		this.btnFilterService.resetFilterData.subscribe(() => { this.resetFilters() })
	}

	getActionHistory(id: number, modal: any) {
		let params = new HttpParams().set('id', id.toString());
		this.httpClient.get('api/Imports/Imports/GetActionHistory', { params: params }).subscribe(actionHistory => {
			this.actionHistory = actionHistory;
			if (this.actionHistory) {
				this.modalService.open(modal, {
					size: 'xl',
					beforeDismiss: () => {
						this.actionHistory = null;
						return true;
					},
				});
			}
		});
	}

	resetFilters() {
		if (sessionStorage.getItem('importListFilters') !== null) {
			sessionStorage.removeItem('importListFilters');
		}
		this.filters = Object.assign(this.filters, this.initFilters);
		this.table.ajaxReload();
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}
}
